import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from '../../general/base/base.component';
import { Company } from '../../../models';
import { IProfessionalsFilter } from '../../../shared/interfaces';
import { ProfessionalsTableComponent } from '../../professionals/professionals-table/professionals-table.component';

@Component({
  selector: 'app-company-tabs',
  templateUrl: './company-tabs.component.html',
  styleUrls: ['./company-tabs.component.scss'],
})
export class CompanyTabsComponent extends BaseComponent implements OnInit {
  @Input() company: Company | undefined = undefined;
  public filters: IProfessionalsFilter | undefined;
  @ViewChild(ProfessionalsTableComponent) professionalsTable?: ProfessionalsTableComponent;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.filters = {
      companyId: this.company?.id,
    };
    if (this.globalCountryId) {
      this.filters.locations = [{ countryId: this.globalCountryId }];
    }
  }
}
